document.addEventListener("DOMContentLoaded", function () {
  // Initialize mobile swiper
  const initMobileSwiper = () => {
    const element = document.querySelector(".swiper-mobile");
    if (!element) return;
    if (typeof Swiper === "undefined") return;

    return new Swiper(element, {
      slidesPerView: 2,
      spaceBetween: 2,
      freeMode: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  };

  // Initialize product focus swiper
  const initProductFocusSwiper = () => {
    const element = document.querySelector(".swiper-product-focus");
    if (!element) return;
    if (typeof Swiper === "undefined") return;

    return new Swiper(element, {
      slidesPerView: 2,
      spaceBetween: 2,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  };

  const swiper = initMobileSwiper();
  const swiperFocus = initProductFocusSwiper();

  // NOTE: Lookbook carousel now uses Alpine autoplayCarousel component
  // See: src/js/alpine/components/autoplayCarousel.js

  // Initialize look section swiper
  const initLookSectionSwiper = () => {
    const element = document.querySelector(".swiper-look-section");
    if (!element) return;
    if (typeof Swiper === "undefined") return;

    return new Swiper(element, {
      slidesPerView: 1,
      spaceBetween: 0,
      watchOverflow: true,
      observer: true,
      loop: true,
      observeParents: true,
      navigation: {
        nextEl: ".section-product-list-focus .swiper-button-next",
        prevEl: ".section-product-list-focus .swiper-button-prev",
      },
    });
  };

  const swiperLook = initLookSectionSwiper();

  // Initialize zoom swiper
  const initZoomSwiper = () => {
    const element = document.querySelector(".swiper-slide-zoom");
    if (!element) return;
    if (typeof Swiper === "undefined") return;

    return new Swiper(element, {
      slidesPerView: 2.1,
      spaceBetween: 0,
      watchOverflow: true,
      centeredSlides: false, // Start without centering
      centerInsufficientSlides: false,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 2.1,
          spaceBetween: 0,
          centeredSlides: false, // Start without centering
          centerInsufficientSlides: false,
          slidesOffsetAfter: 40,
        },
        1024: {
          slidesPerView: 2.1,
          spaceBetween: 16,
          centeredSlides: false, // Start without centering
          centerInsufficientSlides: false,
          slidesOffsetAfter: 60,
        },
      },
      on: {
        init: function () {
          // Set initial opacity for all slides
          this.slides.forEach((slide, index) => {
            /*slide.style.opacity = index === this.activeIndex ? '1' : '0.5';
					slide.style.transition = 'opacity 0.3s ease';*/
          });
        },
        slideChangeTransitionStart: function () {
          // Update opacity for all slides during transition start
          this.slides.forEach((slide, index) => {
            slide.style.opacity = index === this.activeIndex ? "1" : "0.5";
          });

          // Enable centering on first slide interaction
          if (!this.params.centeredSlides) {
            this.params.centeredSlides = true;
            this.params.centerInsufficientSlides = true;

            // Update breakpoints as well
            Object.keys(this.params.breakpoints).forEach((breakpoint) => {
              this.params.breakpoints[breakpoint].centeredSlides = true;
              this.params.breakpoints[
                breakpoint
              ].centerInsufficientSlides = true;
            });

            this.update();
          }
        },
        slideChange: function () {
          // Update opacity for all slides
          this.slides.forEach((slide, index) => {
            slide.style.opacity = index === this.activeIndex ? "1" : "0.5";
          });
        },
      },
    });
  };

  const swiperZoom = initZoomSwiper();

  // Initialize dispatch collections swiper
  const initDispatchCollectionsSwiper = () => {
    const element = document.querySelector(".swiper-dispatch-collections");
    if (!element) return;
    if (typeof Swiper === "undefined") return;

    return new Swiper(element, {
      slidesPerView: "auto",
      speed: 1000,
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: true,
      },
      spaceBetween: 0,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  };

  const swiperDispatchCollections = initDispatchCollectionsSwiper();

  // News carousel with functional approach
  const createNewsCarousel = () => {
    const element = document.querySelector(".swiper-carousel-news");
    if (!element) return;
    if (typeof Swiper === "undefined") return;

    // Configuration constants
    const config = {
      mobile: {
        activeSlideWidth: "66.66%",
        activeSlideMargin: "16.66%",
        nextSlideWidth: "50%",
        nextSlideMargin: "16.66%",
        breakpoint: 991,
      },
      desktop: {
        activeSlideWidth: "37.5%",
        activeSlideMargin: "12.5%",
        nextSlideWidth: "25%",
        nextSlideMargin: "12.5%",
      },
    };

    // Pure function to calculate slide dimensions
    const calculateSlideDimensions = (slides, activeIndex, isMobile) => {
      const settings = isMobile ? config.mobile : config.desktop;

      return slides.map((slide, index) => ({
        element: slide,
        width:
          index <= activeIndex
            ? settings.activeSlideWidth
            : settings.nextSlideWidth,
        marginRight:
          index <= activeIndex
            ? settings.activeSlideMargin
            : settings.nextSlideMargin,
      }));
    };

    // Pure function to apply dimensions to slides
    const applyDimensions = (slideDimensions) => {
      slideDimensions.forEach(({ element, width, marginRight }) => {
        element.style.width = width;
        element.style.marginRight = marginRight;
      });
    };

    // Function to handle all updates in one place
    const updateSlider = (swiper) => {
      const isMobile = window.innerWidth <= config.mobile.breakpoint;
      const slideDimensions = calculateSlideDimensions(
        swiper.slides,
        swiper.activeIndex,
        isMobile
      );
      applyDimensions(slideDimensions);

      // Force complete recalculation
      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();

      // Ensure snap points are updated
      swiper.snapGrid = [...swiper.slidesGrid];

      // Force position update
      swiper.slideTo(swiper.activeIndex, 0, false);
    };

    // Create and return the Swiper instance
    const swiperInstance = new Swiper(element, {
      slidesPerView: "auto",
      spaceBetween: 0,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      speed: 400, // Ensure smooth transitions
      navigation: {
        nextEl: ".carousel-news .swiper-button-next",
        prevEl: ".carousel-news .swiper-button-prev",
      },
      on: {
        init: function () {
          updateSlider(this);
        },
        beforeTransitionStart: function () {
          updateSlider(this);
        },
        slideChange: function () {
          updateSlider(this);
        },
        resize: function () {
          updateSlider(this);
        },
        transitionEnd: function () {
          updateSlider(this);

          // Double-check position after a short delay
          setTimeout(() => {
            updateSlider(this);
          }, 50);
        },
      },
    });

    // Add event listeners to navigation buttons for extra reliability
    const nextButton = document.querySelector(
      ".carousel-news .swiper-button-next"
    );
    const prevButton = document.querySelector(
      ".carousel-news .swiper-button-prev"
    );

    if (nextButton) {
      nextButton.addEventListener("click", () => {
        // Force update after navigation button click
        setTimeout(() => {
          updateSlider(swiperInstance);
        }, 50);
      });
    }

    if (prevButton) {
      prevButton.addEventListener("click", () => {
        // Force update after navigation button click
        setTimeout(() => {
          updateSlider(swiperInstance);
        }, 50);
      });
    }

    return swiperInstance;
  };

  // Initialize the news carousel
  const carouselNews = createNewsCarousel();

  // Initialize gallery thumbnails swiper
  const initGalleryThumbsSwiper = () => {
    const element = document.querySelector(
      ".gallery-thumbnails.gallery-thumbs"
    );
    if (!element) return;
    if (typeof Swiper === "undefined") return;

    return new Swiper(element, {
      spaceBetween: 4,
      slidesPerView: "auto",
      direction: "vertical",
      slideToClickedSlide: true,
      normalizeSlideIndex: true,
      roundLengths: true,
      freeMode: true,
      watchSlidesProgress: true,
      centeredSlides: true,
    });
  };

  // Initialize gallery main swiper
  const initGalleryMainSwiper = (galleryThumbsInstance) => {
    const element = document.querySelector(".gallery-main");
    if (!element) return;
    if (typeof Swiper === "undefined") return;

    const galleryMain = new Swiper(element, {
      spaceBetween: 0,
      navigation: {
        nextEl: ".product-images-gallery .swiper-button-next",
        prevEl: ".product-images-gallery .swiper-button-prev",
      },
      pagination: {
        el: ".product-images-gallery .swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      effect: "creative",
      creativeEffect: {
        prev: {
          shadow: true,
          translate: ["-20%", 0, -1],
        },
        next: {
          translate: ["100%", 0, 0],
        },
      },
      thumbs: {
        swiper: galleryThumbsInstance,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
    });

    // Evento para garantir centralização ao mudar slide
    if (galleryThumbsInstance) {
      galleryMain.on("slideChange", function () {
        galleryThumbsInstance.slideTo(galleryMain.activeIndex, 300, true);
      });
    }

    return galleryMain;
  };

  const galleryThumbs = initGalleryThumbsSwiper();
  const galleryMain = initGalleryMainSwiper(galleryThumbs);

  // Initialize equivalences swiper
  const initEquivalencesSwiper = () => {
    const element = document.querySelector(
      ".custom-product-sidebar__equivalences"
    );
    if (!element) return;
    if (typeof Swiper === "undefined") return;

    return new Swiper(element, {
      slidesPerView: 2,
      spaceBetween: 2,
      navigation: {
        nextEl: ".custom-product-sidebar__equivalences .swiper-button-next",
        prevEl: ".custom-product-sidebar__equivalences .swiper-button-prev",
      },
      breakpoints: {
        1024: {
          slidesPerView: 2.5,
        },
      },
    });
  };

  const equivalences = initEquivalencesSwiper();

  // Create materials swiper using a functional approach
  const createMaterialsSwiper = () => {
    const element = document.querySelector(".material-look-slider .swiper");
    if (!element) return;
    if (typeof Swiper === "undefined") return;

    // Pure function to handle slide animations
    const setSlideState = (slide, isActive) => {
      if (!slide) return;

      const content = slide.querySelector(".material-look-content");
      const description = slide.querySelector(".material-look-description");

      if (content) content.style.opacity = isActive ? "1" : "0";
      if (description)
        description.style.transform = isActive
          ? "translateY(0)"
          : "translateY(20px)";
    };

    // Pure function to update title states
    const updateActiveTitleState = (index) => {
      const materialTitles = document.querySelectorAll(".material-title");
      materialTitles.forEach((title, i) => {
        title.classList.toggle("active", i === index);
      });
    };

    // Create the swiper instance with minimal event handlers
    const swiper = new Swiper(element, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      speed: 500,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      on: {
        init: function () {
          // Set initial states
          const activeSlide = this.slides[this.activeIndex];
          setSlideState(activeSlide, true);
          updateActiveTitleState(this.realIndex);
        },
        slideChange: function () {
          // Use a debounced approach to prevent potential infinite loops
          setTimeout(() => {
            // Only update lookSwiper if it exists and isn't currently transitioning
            if (lookSwiper && !lookSwiper.animating) {
              lookSwiper.slideTo(this.realIndex);
            }
            updateActiveTitleState(this.realIndex);
          }, 0);
        },
      },
    });

    return swiper;
  };

  const materialsSwiper = createMaterialsSwiper();

  // Add click functionality to material titles with functional approach
  const setupMaterialTitles = () => {
    const materialTitles = document.querySelectorAll(
      ".materials-titles .material-title"
    );

    const handleTitleClick = (index) => {
      if (materialsSwiper && !materialsSwiper.animating) {
        materialsSwiper.slideToLoop(index);
      }
    };

    materialTitles.forEach((title, index) => {
      title.addEventListener("click", () => handleTitleClick(index));
    });
  };

  setupMaterialTitles();

  // Initialize material look info swiper
  const initMaterialLookInfoSwiper = () => {
    const element = document.querySelector(".material-look-info-swiper");
    if (!element) return;
    if (typeof Swiper === "undefined") return;

    return new Swiper(element, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      effect: "slide",
      speed: 0,
      allowTouchMove: false,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      on: {
        slideChange: function () {
          // Prevent circular updates by checking if materialsSwiper exists and isn't currently animating
          if (
            materialsSwiper &&
            !materialsSwiper.animating &&
            this.realIndex !== materialsSwiper.realIndex
          ) {
            materialsSwiper.slideTo(this.realIndex);
          }
        },
      },
    });
  };

  const lookSwiper = initMaterialLookInfoSwiper();

  // Initialize size module swiper
  const initSizeModuleSwiper = () => {
    const element = document.querySelector(".size-module-swiper");
    if (!element) return;
    if (typeof Swiper === "undefined") return;

    return new Swiper(element, {
      direction: "horizontal",
      slidesPerView: 1,
      grabCursor: true,
      effect: window.innerWidth >= 1024 ? "creative" : "",
      navigation: {
        nextEl: ".size-module .swiper-button-next",
        prevEl: ".size-module .swiper-button-prev",
      },
      breakpoints: {
        1024: {
          direction: "vertical",
          creativeEffect: {
            prev: {
              shadow: true,
              translate: [0, "-0%", -1],
            },
            next: {
              translate: [0, "100%", 0],
            },
          },
        },
      },
      speed: 800,
    });
  };

  // Initialize size module thumbs swiper
  const initSizeModuleThumbsSwiper = (sizeModuleSwiperInstance) => {
    const element = document.querySelector(".size-module-block__thumbs-list");
    if (!element) return;
    if (typeof Swiper === "undefined") return;

    const sizeModuleThumbsSwiper = new Swiper(element, {
      direction: "horizontal",
      slidesPerView: "auto",
      spaceBetween: 0,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      breakpoints: {
        1024: {
          direction: "vertical",
          slidesPerView: "auto",
          spaceBetween: 16,
          centeredSlides: true,
          centerInsufficientSlides: true,
        },
      },
      on: {
        click: function (swiper, event) {
          const clickedIndex = swiper.clickedIndex;
          if (sizeModuleSwiperInstance) {
            sizeModuleSwiperInstance.slideTo(clickedIndex);
          }
        },
        slideChange: function () {
          const headings = document.querySelector(
            ".size-module-block__headings--animation"
          );
          if (headings) {
            if (this.activeIndex === 0) {
              headings.classList.remove("swiper-scrolled-init");
            } else {
              headings.classList.add("swiper-scrolled-init");
            }
          }
        },
      },
      speed: 800,
    });

    // Sync both swipers
    if (sizeModuleSwiperInstance) {
      sizeModuleSwiperInstance.on("slideChange", function () {
        if (sizeModuleThumbsSwiper) {
          sizeModuleThumbsSwiper.slideTo(sizeModuleSwiperInstance.activeIndex);
        }
      });

      sizeModuleThumbsSwiper.on("slideChange", function () {
        if (sizeModuleSwiperInstance) {
          sizeModuleSwiperInstance.slideTo(sizeModuleThumbsSwiper.activeIndex);
        }
      });
    }

    return sizeModuleThumbsSwiper;
  };

  const sizeModuleSwiper = initSizeModuleSwiper();
  const sizeModuleThumbsSwiper = initSizeModuleThumbsSwiper(sizeModuleSwiper);

  // Initialize customer order image swipers
  const initCustomerOrderImageSwipers = () => {
    if (typeof Swiper === "undefined") return;

    const orderImageElements = document.querySelectorAll(
      ".customer .order__image"
    );
    if (orderImageElements.length === 0) return;

    orderImageElements.forEach(function (orderImageEl) {
      if (!orderImageEl) return;
      new Swiper(orderImageEl, {
        slidesPerView: 2,
        spaceBetween: "2px",
        breakpoints: {
          1024: {
            slidesPerView: 4,
          },
        },
        navigation: {
          nextEl: orderImageEl.querySelector(".swiper-button-next"),
          prevEl: orderImageEl.querySelector(".swiper-button-prev"),
        },
      });
    });
  };

  initCustomerOrderImageSwipers();

  // Initialize wishlist resume swiper
  const initWishlistResumeSwiper = () => {
    const element = document.querySelector(".wishlist-resume");
    if (!element) return;
    if (typeof Swiper === "undefined") return;

    return new Swiper(element, {
      slidesPerView: 3,
      spaceBetween: 2,
      breakpoints: {
        1024: {
          slidesPerView: 8,
        },
      },
    });
  };

  const wishlistResume = initWishlistResumeSwiper();
});
